import React, { useState, useEffect } from 'react';
import Index from './index';
import ViewCampaign from './viewCampaign';
import EditCampaign from './editCampaign';

 const  Main =props => {
 const [page, handlePage] = useState(1);
 const [campaign, handleCampaign] = useState(1);

 //Handle Next Page
  const nextPage = () => {
   handlePage(page + 1);
  };

  //Handle Previous Page
  const previousPage = () => {

    handlePage(page - 1);
  };

  //Get campaign details
  const getCampaignDetails = data =>{
    handleCampaign(data);
  }

  const firstPage =()=>{
    handlePage(1)
  }


    if (page === 1) {
      return <Index 
      onSubmit={nextPage} 
      getCampaignDetails={getCampaignDetails}
      previousPage={previousPage}
       />;
    }
    if (page === 2) {
      return (
        <ViewCampaign
          handleBack={previousPage}
          campaign={campaign}
        
        />
      );
    }

    return null;
  }

export default Main;



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/main.js